module.exports = __webpack_public_path__ + "media/images/themes/mandy/16-eddde75ac0c624ec5c8aa0c9dafdf573.png";